import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/clock/clock.js';
      

      export interface Props {
     date?: string;
     showSeconds?: boolean;
     showDate?: boolean;
     showTimezone?: boolean;
     timeZoneOffsetHours?: number;
     isClickable?: boolean;
     showYear?: boolean;
     showWeekday?: boolean;
     locale?: string;
     hour12?: boolean;
     selected?: boolean;
     double?: boolean;
     activated?: boolean;
     integrationBarMode?: boolean;
     blinkOnlyBreakpointPx?: number
   }

      
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcClock',
  props: {
    date: {},
    showSeconds: { type: Boolean },
    showDate: { type: Boolean },
    showTimezone: { type: Boolean },
    timeZoneOffsetHours: {},
    isClickable: { type: Boolean },
    showYear: { type: Boolean },
    showWeekday: { type: Boolean },
    locale: {},
    hour12: { type: Boolean },
    selected: { type: Boolean },
    double: { type: Boolean },
    activated: { type: Boolean },
    integrationBarMode: { type: Boolean },
    blinkOnlyBreakpointPx: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-clock',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})